import * as React from 'react';
import { IChallengeItem } from '../helpers/fetch-service';

enum templateReducerActions {
  SET_TEMPLATE_ITEM = 'SET_TEMPLATE_ITEM',
  SET_PARAMETERS = 'SET_PARAMETERS',
}

export interface IAction {
  type: string;
  payload: any;
}
interface IState {
  templateItem: IChallengeItem | null;
  parameters: { [key: string]: string | null | number };
}
type TemplateProviderProps = { children: React.ReactNode };

const TemplateStateContext = React.createContext<{ state: IState; dispatch: React.Dispatch<IAction> } | undefined>(
  undefined,
);

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
function templateReducer(state: IState, action: IAction) {
  switch (action.type) {
    case templateReducerActions.SET_TEMPLATE_ITEM: {
      return { ...state, templateItem: action.payload };
    }
    case templateReducerActions.SET_PARAMETERS: {
      return { ...state, parameters: action.payload };
    }
    default: {
      return state;
      // throw new Error(`Unhandled action type: ${action.type}`);
    }
  }
}

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
function TemplateProvider({ children }: TemplateProviderProps) {
  const [state, dispatch] = React.useReducer(templateReducer, {
    templateItem: null,
    parameters: {},
  });
  const value = { state, dispatch };

  return <TemplateStateContext.Provider value={value}>{children}</TemplateStateContext.Provider>;
}

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
function useTemplate() {
  const context = React.useContext(TemplateStateContext);
  if (context === undefined) {
    throw new Error('useTemplate must be used within a TemplateProvider');
  }
  return context;
}

export function setTemplateItem(dispatch: React.Dispatch<IAction>, templateItem: IChallengeItem | null): void {
  dispatch({ type: templateReducerActions.SET_TEMPLATE_ITEM, payload: templateItem });
}

export function setParameters(
  dispatch: React.Dispatch<IAction>,
  parameters: { [key: string]: string | null | number },
): void {
  dispatch({ type: templateReducerActions.SET_PARAMETERS, payload: parameters });
}

export { TemplateProvider, useTemplate };
